import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { KaleRootState, KaleRootDispatch } from "src/redux/store";

export const useKaleDispatch: () => KaleRootDispatch = useDispatch;
export const useKaleSelector: TypedUseSelectorHook<KaleRootState> = useSelector;
